import { createAction, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export type AppDrawerSliceStateDef = {
    key?: string;
    activeDrawer?: React.JSX.Element;
};

const initialState: AppDrawerSliceStateDef = {};

export const openAppDrawer = createAction<{ key: string; element: React.JSX.Element }>(
    "lobbie/app/drawer/openAppDrawer",
);
export const closeAppDrawer = createAction<string>("lobbie/app/drawer/closeAppDrawer");

const AppDrawerSlice = createSlice({
    name: "AppDrawerSlice",
    initialState,
    reducerPath: "lobbie/app/drawer",
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(openAppDrawer, (state, action) => ({
                ...state,
                key: action.payload.key,
                activeDrawer: action.payload.element,
            }))
            .addCase(closeAppDrawer, (state, action) =>
                action.payload === state.key
                    ? {
                          ...state,
                          key: undefined,
                          activeDrawer: undefined,
                      }
                    : state,
            ),
});

export const isActiveDrawer = (key: string) => (state: RootState) =>
    state["lobbie/app/drawer"].key === key;

export default AppDrawerSlice;
